// extracted by mini-css-extract-plugin
export default {"AppOsefBar":"AppOsef_AppOsefBar__DfKWQ"};